import React from "react";
import { FiMapPin } from "react-icons/fi";
import Logo from "../styles/Black-SVG-Landscape.svg";
import ChrisPhoto from "../candidates/jonathanme.jpg";



export default function HeadOfPartnershipsJonathanM() {
 const candidateProfileCopy = {
  name: "Jonathan",
  location: "Houston, TX",
  compensation: {
    range: "$180K base, $250K+ OTE target",
  },
  availability: "Available immediately upon offer",

  working_style:
    "Jonathan is a high energy, data driven partnerships leader who builds and then delegates. He goes in prepared, does the research, maps the stakeholders, and builds a clear strategic plan for his team to execute, then leads from the front, in the field and on calls with his reps. He thrives on big, multi year strategic deals and on building a function from nothing, and he leans on numbers and ROI to decide where to focus.",

  loom_video_link: "https://fathom.video/share/heWzUnX_pPMANowu3ey32AVGXWT5j2vy",

  tools: [
    {
      category: "Partnership & Deal Making",
      items: [
        "Closing six and seven figure multi year partnership deals",
        "Structuring and negotiating complex agreements",
        "Leveraging long term relationships across organizations",
      ],
    },
    {
      category: "Building & Scaling",
      items: [
        "Built entire BD departments and pipelines from scratch",
        "Pipeline governance, KPIs, and forecasting discipline",
        "Generated over $240M in new revenue",
      ],
    },
    {
      category: "Team Leadership",
      items: [
        "Led a 30 person sales team to 12 straight quarters above quota",
        "Hands on coaching, in the field and on calls",
        "Incentive and culture programs that drive performance",
      ],
    },
    {
      category: "Commercial & Tools",
      items: [
        "Data and ROI driven partner evaluation",
        "CAC and recurring revenue focus",
        "HubSpot, Salesforce, and project management tools",
      ],
    },
  ],

  soft_skills: [
    "18 plus years in strategic partnerships and business development",
    "Generated over $240M in new revenue",
    "Built entire BD departments from scratch",
    "Hands on leader of a 30 person sales team",
  ],

  about_candidate:
    "Jonathan is a partnerships and business development executive with more than 18 years building and scaling partnership programs, having driven over $240M in new revenue. At his most recent company he built the entire business development department from scratch, led a 30 person team, and beat quota for 12 straight quarters, and earlier he closed a $37M multi year agreement with a national government. He has structured major partnerships with brands like the NFL, FedEx, and Mercedes, brings sharp, data driven commercial instincts, and is energized by building something from nothing.",

  core_strengths: [
    {
      headline: "Elite partnership and revenue track record",
      description:
        "Jonathan has driven over $240M in new revenue and closed major multi year deals with brands like the NFL and FedEx, plus a $37M agreement with a national government. The scale and consistency of his partnership results stand out.",
    },
    {
      headline: "Builds the whole engine from scratch",
      description:
        "He built an entire business development department from nothing at one company and rebuilt a partnership pillar at another, including the pipeline, KPIs, and team. Starting from a blank page is exactly where he thrives.",
    },
    {
      headline: "Sharp, data driven commercial mind",
      description:
        "He evaluates partners by what they cost versus what they return, cuts the ones that do not pay off, and focuses on recurring revenue. He naturally connected that thinking to recurring prescription revenue in the interview.",
    },
    {
      headline: "Hands on leader who builds winning teams",
      description:
        "He led a 30 person sales team to above quota results for 12 straight quarters, coaching in the field, riding along on calls, and building a culture his reps wanted to win for.",
    },
  ],

  relevant_experience: [
    {
      headline: "VP, Business Development and Growth | WellBe Financial | 2022 to 2026",
      bullets: [
        "Built the entire business development department from scratch and led a 30 person team",
        "Drove over $240M in new revenue and 16,000 plus new members",
        "Beat quota for 12 consecutive quarters, peaking at 125 percent",
      ],
    },
    {
      headline: "Director, Global Partnerships | Global Entrepreneurship Network | 2021 to 2022",
      bullets: [
        "Closed a $37M multi year agreement with a national government",
        "Grew revenue opportunities 70 percent through new partnership development",
        "Led a 20 person global partnership and marketing team",
      ],
    },
    {
      headline: "Senior Consultant | National Black MBA Association | 2017 to 2021",
      bullets: [
        "Generated over $10M through strategic partnerships and sales",
        "Surpassed targets every year, from 108 to 120 percent",
        "Directed a sales team of 20 and managed a multi million dollar pipeline",
      ],
    },
    {
      headline: "Manager, Track Rental Sales | Road Atlanta | 2015 to 2016",
      bullets: [
        "Grew annual sales 25 percent, from $4M to $5M",
        "Secured over $9M in contracts with major automotive brands",
        "Managed a $5M budget as the lead point of contact",
      ],
    },
  ],
};

const technicalAssessment = {
  meta: {
    role: "Head of Healthcare Partnerships",
    interviewDate: "June 5, 2026",
    analyst: "AI Architechs Senior Hiring Analysis",
  },

  snapshot:
    "Jonathan is a high horsepower partnerships and business development leader who has built BD departments from scratch and driven over $240M in new revenue. He thinks in data and ROI, leads a sales team hands on, and has closed major multi year partnership deals with some of the largest brands in the country, plus a $37M government agreement. The honest tradeoff is domain: his partnerships are with big brands and in financial services, not healthcare providers, so the clinical and prescriber side, and healthcare compliance, would all be new ground. His style leans toward closing and big deals more than the slow, high touch clinical relationship this market often rewards. He is in range on pay and could start immediately.",

  scorecard: [
    {
      dimension: "Partnership and Referral Channel Development",
      score: 9,
      rationale:
        "An elite partnership track record: over $240M in revenue, six and seven figure multi year deals with brands like the NFL and FedEx, and a $37M government agreement. The core skill of building and growing major partnerships is clearly there, with the caveat that his channels have been brand and sponsorship partnerships rather than clinical referrals.",
    },
    {
      dimension: "Building From Zero and Pipeline Construction",
      score: 9,
      rationale:
        "He built an entire business development department from nothing at one company and rebuilt a partnership pillar at another, including pipeline governance, KPIs, CAC tracking, and forecasting. Strong, proven build from zero with real pipeline construction behind it.",
    },
    {
      dimension: "Revenue and Commercial Thinking",
      score: 9,
      rationale:
        "Sharp and numbers first. He evaluates partners by cost versus accounts gained, cuts the low return ones, and focuses on recurring revenue, and he connected that directly to recurring prescription revenue for this role. Strong commercial discipline.",
    },
    {
      dimension: "Partner Conversion and Lifecycle Management",
      score: 7,
      rationale:
        "Confident and effective at aligning on a win win and closing, which he considers the easy part. His answer leaned toward closing the deal more than the long term onboarding, activation, and nurture that keep a partnership growing, which matters in a relationship led market.",
    },
    {
      dimension: "SDR and Sales Team Leadership",
      score: 9,
      rationale:
        "Led a 30 person sales team to above quota results for 12 straight quarters, coaching in the field and on calls and building incentive and culture programs that lifted performance. Genuine, hands on leadership at scale.",
    },
    {
      dimension: "Regulated Healthcare Experience and Compliance",
      score: 5,
      rationale:
        "He has operated carefully inside a heavily regulated industry in finance, partnering closely with risk and legal on every go to market move, so the discipline transfers. But he has no healthcare or HIPAA experience, so the specific compliance side would be new.",
    },
    {
      dimension: "Fertility and Women's Health Vertical Exposure",
      score: 4,
      rationale:
        "No healthcare vertical experience at all, and no fertility or women's health exposure. He grasped the recurring prescription model conceptually in the interview, but this is his clearest gap and the area he would need to learn from the ground up.",
    },
    {
      dimension: "Ambition and Drive",
      score: 9,
      rationale:
        "Exceptional. He has built functions from scratch, driven $240M in revenue, beaten quota for 12 straight quarters, and is pursuing a global executive MBA, with immediate availability and in range pay. The hunger and ownership are obvious.",
    },
  ],

  strengths: [
    {
      headline: "Elite partnership and revenue track record",
      description:
        "Jonathan has driven over $240M in new revenue and closed major multi year deals with brands like the NFL and FedEx, plus a $37M government agreement. The raw partnership horsepower is exceptional.",
    },
    {
      headline: "Builds the engine from scratch",
      description:
        "He built an entire business development department from nothing and rebuilt a partnership pillar at another company, including the pipeline, KPIs, and team. Starting from a blank page is squarely in his wheelhouse.",
    },
    {
      headline: "Data and ROI driven",
      description:
        "He evaluates partners by cost versus return, cuts the ones that do not pay off, and focuses on recurring revenue, exactly the commercial discipline a growth target needs.",
    },
    {
      headline: "Hands on team leader",
      description:
        "He has led a 30 person sales team to above quota results for 12 straight quarters, coaching in the field and building a culture his reps wanted to win for.",
    },
  ],

  flags: [
    {
      headline: "No healthcare or clinical experience",
      description:
        "His partnerships are with major brands and in financial services, not healthcare providers or clinics. He understands the recurring revenue idea, but the clinical, prescriber, and compliance side would all be new ground.",
    },
    {
      headline: "Big brand style, not clinical referral",
      description:
        "His wins are large sponsorship, co marketing, and enterprise deals. The high touch, trust based clinical referral motion is different, and his view that closing is the easy part is worth testing against a slower healthcare sale.",
    },
    {
      headline: "More closer than long term nurturer",
      description:
        "He framed converting partners mostly around closing the deal. Worth confirming he will invest in the long term partner relationship and retention this role depends on.",
    },
  ],

  when_to_hire: [
    "You want the highest raw partnership and revenue horsepower in the group and are open to someone bringing it into healthcare.",
    "You need someone who can build the whole BD function and pipeline from scratch, since he has done exactly that.",
    "Data, ROI, and disciplined pipeline management matter to you.",
    "You want a hands on sales leader who can build and drive a high performing team.",
  ],

  when_to_be_cautious: [
    "You need someone who already knows healthcare, clinical referrals, and the compliance side, since all of that would be new for him.",
    "Your market rewards slow, high touch, relationship led selling more than big deal closing.",
    "You want proven fertility or women's health experience, which he does not have.",
  ],

  bottom_line:
    "Jonathan brings the strongest raw partnership and business development horsepower in this group: over $240M in revenue, BD departments built from scratch, elite deal making, and hands on team leadership, all with real drive and immediate availability. The open question is domain, since his world has been big brands and financial services rather than healthcare, so clinical referrals and compliance would be a genuine ramp, and his style leans toward closing over long term nurture. He is the high upside bet if you are open to coaching an exceptional builder into the healthcare side.",
};

  const ScorePill = ({ score }) => {
    let bg = "#f97316";
    if (score >= 8) bg = "#22c55e";
    else if (score >= 6) bg = "#36D1FF";
    return (
      <span
        style={{ backgroundColor: bg }}
        className="inline-block text-white text-xs font-bold px-3 py-1 rounded-full"
      >
        {score} / 10
      </span>
    );
  };

  return (
    <div className="min-h-screen bg-[#01014C] text-white flex flex-col items-center py-10 px-4">

      {/* ===================== PAGE 1 ===================== */}
      <div className="w-full max-w-6xl bg-[#FFFDFB] rounded-3xl overflow-hidden shadow-2xl flex flex-col md:flex-row relative">

        {/* LEFT COLUMN */}
        <aside className="relative md:w-1/3 bg-gradient-to-b from-[#01014C] via-[#0A0A80] to-[#36D1FF] p-8 flex flex-col items-center text-center overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-24 bg-gradient-to-b from-[#36D1FF]/30 to-transparent"></div>

          {/* Avatar placeholder */}
          <div className="relative mb-4">
            <div className="absolute inset-0 rounded-full bg-[#36D1FF]/20 blur-2xl"></div>
            <div className="relative w-36 h-36 rounded-full border-4 border-[#36D1FF] shadow-lg overflow-hidden">
              <img src={ChrisPhoto} alt="Chris Weston" className="w-full h-full object-cover" />
            </div>
          </div>

          {/* Name */}
          <h1 className="text-2xl font-semibold mb-1 text-[#FFFDFB]">
            {candidateProfileCopy.name}
          </h1>

          {/* Location */}
          <div className="flex items-center gap-2 text-[#E0F7FF] text-sm mb-6 opacity-90">
            <FiMapPin className="text-[#36D1FF]" />
            <span>{candidateProfileCopy.location}</span>
          </div>

          {/* Compensation */}
          <div className="bg-[#01014C] border border-[#36D1FF]/50 rounded-xl p-4 w-full text-left mb-4">
            <p className="text-[#B3E9FF] text-sm font-semibold uppercase mb-1">
              Compensation
            </p>
            <p className="text-[#36D1FF] text-lg font-bold">
              {candidateProfileCopy.compensation.range}
            </p>
          </div>

          {/* Availability */}
          <div className="bg-[#01014C] border border-[#36D1FF]/30 rounded-xl p-4 w-full text-left mb-6">
            <p className="text-[#E0F7FF] text-sm">
              {candidateProfileCopy.availability}
            </p>
          </div>

          {/* Watch Interview Button */}
          <a
            href={candidateProfileCopy.loom_video_link}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full mb-6 flex items-center justify-center gap-2 bg-gradient-to-r from-[#36D1FF] to-[#0099CC] hover:from-[#5DDDFF] hover:to-[#00AADD] text-[#01014C] font-bold text-sm py-3 px-6 rounded-xl transition-all duration-200 shadow-lg shadow-[#36D1FF]/20 hover:shadow-[#36D1FF]/40"
          >
            ▶ Watch Interview
          </a>

          {/* Tools */}
          <div className="w-full mt-4 mb-6 text-left">
            <h3 className="text-sm font-semibold mb-3 text-[#B3E9FF] uppercase">
              Tools & Capabilities
            </h3>
            {candidateProfileCopy.tools.map((group, i) => (
              <div key={i} className="mb-4">
                <p className="text-xs font-semibold text-[#36D1FF] mb-1 uppercase tracking-wide">
                  {group.category}
                </p>
                <ul className="space-y-1">
                  {group.items.map((tool, j) => (
                    <li
                      key={j}
                      className="flex items-start gap-2 text-xs text-[#E0F7FF]/90 leading-snug"
                    >
                      <span className="mt-1 w-1.5 h-1.5 rounded-full bg-[#36D1FF] shrink-0" />
                      {tool}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Soft Skills */}
          <div className="w-full mb-6 text-left">
            <h3 className="text-sm font-semibold mb-2 text-[#B3E9FF] uppercase">
              Key Profile Highlights
            </h3>
            <ul className="list-disc pl-5 space-y-1 text-[#E0F7FF] text-sm">
              {candidateProfileCopy.soft_skills.map((skill, i) => (
                <li key={i}>{skill}</li>
              ))}
            </ul>
          </div>

          {/* Logo placeholder */}
          <div className="w-full mt-8 flex justify-center">
            <img src={Logo} alt="AI Architechs" className="h-16 opacity-80" />
          </div>
        </aside>

        {/* RIGHT COLUMN */}
        <main className="flex-1 p-10 text-[#01014C] space-y-10">
          <section>
            <h2 className="text-xl font-semibold mb-3 border-b border-[#36D1FF]/40 pb-1">
              About this Candidate
            </h2>
            <p className="text-gray-700 leading-relaxed whitespace-pre-line">
              {candidateProfileCopy.about_candidate}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 border-b border-[#36D1FF]/40 pb-1">
              Core Strengths
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              {candidateProfileCopy.core_strengths.map((item, i) => (
                <div key={i} className="border border-[#36D1FF]/30 rounded-xl p-5">
                  <p className="font-semibold mb-1">{item.headline}</p>
                  <p className="text-sm text-gray-700">{item.description}</p>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 border-b border-[#36D1FF]/40 pb-1">
              Relevant Experience
            </h2>
            <div className="space-y-6">
              {candidateProfileCopy.relevant_experience.map((exp, i) => (
                <div key={i} className="border border-[#36D1FF]/30 rounded-xl p-5">
                  <p className="font-semibold text-[#EB5D2A] mb-2">{exp.headline}</p>
                  <ul className="list-disc pl-6 space-y-1 text-sm text-gray-700">
                    {exp.bullets.map((b, j) => (
                      <li key={j}>{b}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </section>
        </main>
      </div>

      {/* ===================== PAGE BREAK BAND ===================== */}
      <div className="w-full py-10">
        <div className="max-w-6xl mx-auto px-4">
          <div className="h-10 rounded-2xl bg-gradient-to-r from-[#01014C] via-[#0A0A80] to-[#36D1FF] opacity-70 shadow-[0_0_40px_#36D1FF20]" />
        </div>
      </div>

      {/* ===================== PAGE 2 ===================== */}
      <div className="w-full max-w-6xl bg-[#FFFDFB] rounded-3xl overflow-hidden shadow-2xl pb-2">
        <main className="p-10 text-[#01014C]">
          <div className="border border-[#36D1FF]/25 rounded-2xl p-6 bg-white shadow-[0_0_12px_#36D1FF15]">

            {/* Header */}
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-2 mb-6">
              <h2 className="text-2xl font-semibold text-[#01014C]">
                Technical Analysis
              </h2>
              <div className="flex flex-col items-start md:items-end gap-1 text-xs text-gray-400">
                <span>{technicalAssessment.meta.role}</span>
                <span>Interview: {technicalAssessment.meta.interviewDate}</span>
                <span>{technicalAssessment.meta.analyst}</span>
              </div>
            </div>

            {/* Snapshot */}
            <div className="border border-[#36D1FF]/20 rounded-xl p-5 bg-[#36D1FF]/5 mb-6">
              <p className="text-base font-bold text-[#01014C] mb-2">Executive Fit Snapshot</p>
              <p className="text-gray-700 text-base leading-relaxed whitespace-pre-line">
                {technicalAssessment.snapshot}
              </p>
            </div>

            {/* Strengths & Flags */}
            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div>
                <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                  ✅ Strengths
                </h3>
                <div className="space-y-3">
                  {technicalAssessment.strengths.map((item, i) => (
                    <div key={i} className="border border-[#22c55e]/30 rounded-xl p-4 bg-[#22c55e]/5">
                      <p className="font-semibold text-sm text-[#01014C] mb-1">{item.headline}</p>
                      <p className="text-sm text-gray-700">{item.description}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                  ⚠️ Flags / Watch-outs
                </h3>
                <div className="space-y-3">
                  {technicalAssessment.flags.map((item, i) => (
                    <div key={i} className="border border-[#f97316]/30 rounded-xl p-4 bg-[#f97316]/5">
                      <p className="font-semibold text-sm text-[#01014C] mb-1">{item.headline}</p>
                      <p className="text-sm text-gray-700">{item.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Scorecard */}
            <div className="mb-6">
              <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                Quantitative Scorecard
              </h3>
              <div className="overflow-x-auto rounded-xl border border-[#36D1FF]/25">
                <table className="w-full text-sm">
                  <thead className="bg-[#36D1FF]/10 text-[#01014C]">
                    <tr>
                      <th className="text-left font-semibold px-4 py-3">Dimension</th>
                      <th className="text-left font-semibold px-4 py-3 w-[120px]">Score</th>
                      <th className="text-left font-semibold px-4 py-3">Rationale</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-[#36D1FF]/15">
                    {technicalAssessment.scorecard.map((row, idx) => (
                      <tr key={idx} className="bg-white">
                        <td className="px-4 py-3 font-medium text-[#01014C] align-top">{row.dimension}</td>
                        <td className="px-4 py-3 align-top"><ScorePill score={row.score} /></td>
                        <td className="px-4 py-3 text-gray-700 whitespace-pre-line align-top">{row.rationale}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* When to Hire / Cautions */}
            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div>
                <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                  ✅ Hire if…
                </h3>
                <div className="space-y-3">
                  {technicalAssessment.when_to_hire.map((item, i) => (
                    <div key={i} className="border border-[#36D1FF]/30 rounded-xl p-4 bg-[#36D1FF]/5 text-sm text-gray-700">
                      {item}
                    </div>
                  ))}
                </div>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                  ⚠️ Be cautious or pass if…
                </h3>
                <div className="space-y-3">
                  {technicalAssessment.when_to_be_cautious.map((item, i) => (
                    <div key={i} className="border border-[#f59e0b]/30 rounded-xl p-4 bg-[#f59e0b]/5 text-sm text-gray-700">
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Bottom Line */}
            <div className="border border-[#01014C]/20 rounded-xl p-5 bg-[#01014C]/5">
              <p className="text-sm font-bold text-[#01014C] mb-2 uppercase tracking-wide">
                🏁 Bottom Line
              </p>
              <p className="text-gray-700 text-sm leading-relaxed">
                {technicalAssessment.bottom_line}
              </p>
            </div>

          </div>
        </main>
      </div>

    </div>
  );
}